import { action, computed, observable } from 'mobx';

import httpFacade from 'http/httpFacade';
import Log from 'helpers/log';
import MenuDesignForm from 'stores/Forms/Menu/MenuDesignForm';
import { PromiseService } from 'services/PromiseService';

export const enum MenuDesignSteps {
  Default,
  Editor,
}

class MenuDesignStore {
  @observable step = MenuDesignSteps.Default;
  @observable backgroundImageUrl = '';
  @observable form = new MenuDesignForm();

  @observable private _promiseService = new PromiseService();

  constructor() {
    this._promiseService.add(this.fetchBackgroundImage);
  }

  @action.bound
  async fetchBackgroundImage() {
    try {
      const { data } = await httpFacade.menu.fetchBackgroundImage();
      if (!data) return;

      this.backgroundImageUrl = data;
    } catch (error) {
      Log.warn(error);
    }
  }

  async setBackgroundImage(file: FormData | null) {
    try {
      if (!file) return;

      await httpFacade.menu.setBackgroundImage(file);
    } catch (error) {
      Log.warn(error);
    }
  }

  async submit() {
    const formData = new FormData();
    formData.append('file', this.form.editedFile);

    await this._promiseService.add(() => this.setBackgroundImage(formData));
  }

  @action.bound
  setStep(step: MenuDesignSteps) {
    this.step = step;
  }

  @computed
  get isInit() {
    return this._promiseService.completedOnce;
  }

  @computed
  get loading() {
    return this._promiseService.isPending;
  }
}

export default MenuDesignStore;
